import React from "react";
import MoreVertOutlined from "@mui/icons-material/MoreVert";
import AccountBalanceWalletOutlined from "@mui/icons-material/AccountBalanceWalletOutlined";
import NotificationsActiveOutlined from "@mui/icons-material/NotificationsActiveOutlined";
import FlagOutlined from "@mui/icons-material/FlagOutlined";
import AutorenewOutlined from "@mui/icons-material/AutorenewOutlined";
import ReportProblemOutlined from "@mui/icons-material/ReportProblemOutlined";

const PayrollOverview = () => {
  return (
    <div  sx={{ borderRadius: "3px",    border: "1px solid #eee",
 }} className="card bg-dark position-relative overflow-hidden text-white border-0">

      {/* Background Image */}
      <img
        src="/assets/img/bg/bg-04.png"
        alt="bg"
        className="position-absolute top-0 start-0 w-100 h-100"
        style={{
          objectFit: "cover",
          opacity: 0.7
        }}
      />

      <div className="card-body position-relative">

        {/* Header */}
        <div className="d-flex justify-content-between align-items-center mb-4">
          <h5 className="mb-0 fw-semibold">Overview</h5>

          <button className="btn btn-light btn-sm rounded-circle p-1 d-flex align-items-center">
            <MoreVertOutlined style={{ fontSize: 18 }} />
          </button>
        </div>

        {/* Top Stats */}
        <div className="d-flex justify-content-between mb-4 flex-wrap gap-3">

          {/* Gross */}
          <div className="d-flex align-items-center gap-3">
            <div
              className="rounded-circle d-flex align-items-center justify-content-center"
              style={{
                width: 60,
                height: 60,
                background: "#ff7a00"
              }}
            >
              <AccountBalanceWalletOutlined />
            </div>

            <div>
              <h4 className="fw-bold mb-1">$2,458,320</h4>
              <small>Total Gross Payroll</small>
            </div>
          </div>

          {/* Net */}
          <div className="d-flex align-items-center gap-3">
            <div
              className="rounded-circle d-flex align-items-center justify-content-center"
              style={{
                width: 60,
                height: 60,
                background: "#17c1e8"
              }}
            >
              <NotificationsActiveOutlined />
            </div>

            <div>
              <h4 className="fw-bold mb-1">$1,987,450</h4>
              <small>Net Payable Amount</small>
            </div>
          </div>

        </div>

        {/* Bottom Cards */}
        <div className="d-flex gap-3 mt-1">

          {/* Deduction */}
          <div className="card w-100 text-center border-0">
            <div className="card-body">
              <div className="mb-3">
                <div className="rounded-circle bg-light mx-auto d-flex align-items-center justify-content-center"
                  style={{ width: 60, height: 60 }}>
                  <FlagOutlined />
                </div>
              </div>
              <h5 className="fw-bold">$1,987,450</h5>
              <small>Total Deductions</small>
            </div>
          </div>

          {/* Pending */}
          <div className="card w-100 text-center border-0">
            <div className="card-body">
              <div className="mb-3">
                <div className="rounded-circle bg-light mx-auto d-flex align-items-center justify-content-center"
                  style={{ width: 60, height: 60 }}>
                  <AutorenewOutlined />
                </div>
              </div>
              <h5 className="fw-bold">12</h5>
              <small>Pending Approvals</small>
            </div>
          </div>

          {/* Errors */}
          <div className="card w-100 text-center border-0">
            <div className="card-body">
              <div className="mb-3">
                <div className="rounded-circle bg-light mx-auto d-flex align-items-center justify-content-center"
                  style={{ width: 60, height: 60 }}>
                  <ReportProblemOutlined />
                </div>
              </div>
              <h5 className="fw-bold">24</h5>
              <small>Total Payroll Errors</small>
            </div>
          </div>

        </div>

      </div>
    </div>
  );
};

export default PayrollOverview;